<template>
  <div class="box box--idea">
    <div class="box-mobile-tag d-lg-none">
      <span>
        <i :class="`icon-${statusIcon(idea._embedded.Content.status)}`"></i>
        {{ idea._embedded.Content.status | capitalize}}
      </span>
      <template v-if="isOpenVoting(idea.votingDeadline)">
        <span>Voting open</span>
        <span>{{idea.votingDeadline | timeTo}}</span>
      </template>
      <template v-else>
        <span>Voting closed</span>
      </template>


      <div class="box-mobile-tag-right">
        <i v-if="(typeof idea.featured === 'string' || idea.featured instanceof String) && idea.featured" class="icon-fav-empty" />
        <!--<i v-if="Object.keys(idea.challenge).length !== 0" class="icon-flag" />-->
      </div>
    </div>

    <div class="box-img-wrapper">
      <ImageWrapper :file="idea.idFile" class="idea-thumbnail-img"></ImageWrapper>
      <ImageWrapper :file="idea.idFile" class="idea-thumbnail-img-mobile"></ImageWrapper>

      <span class="box-img-tag-top d-none d-lg-flex">
         <template v-if="isOpenVoting(idea.votingDeadline)">
        <span>Voting open</span>
        <span>{{idea.votingDeadline | daysToVote}}</span>
        </template>
        <template v-else>
          <span>Voting closed</span>
        </template>
      </span>

      <span class="box-img-tag-left d-none d-lg-flex" v-if="idea._embedded.Content.status !== 'VOTING'">
        <i :class="`icon-${statusIcon(idea._embedded.Content.status)}`"></i>
        {{ idea._embedded.Content.status | capitalize}}
      </span>

      <div class="box-img-tag-right d-none d-lg-flex">
        <i v-if="(typeof idea.featured === 'string' || idea.featured instanceof String) && idea.featured" class="icon-fav-empty" />
        <!--<i v-if="Object.keys(idea.challenge).length !== 0" class="icon-flag" />-->
      </div>
    </div>

    <div class="box-inner">
      <span class="box-tag">
        <span>{{ idea._embedded.Category.value }}</span>
        <span>{{ idea._embedded.Content.createdAt | timeSince('UTC', true) }}</span>
      </span>
      <span class="box-title">{{ idea.headline }}</span>
      <div class="box-bottom">
        <span class="span-icon"><i class="icon-vote-empty"></i> {{ idea.votes }}</span>
        <span class="span-icon"><i class="icon-comment"></i> {{ idea.commentsCounter }}</span>
      </div>
    </div>

    <div class="box-hover">
      <span class="box-tag">
        <span>{{ idea._embedded.Category.value }}</span>
        <span>{{ idea._embedded.Content.createdAt | timeSince('UTC', true) }}</span>
      </span>
      <router-link class="box-title" :to="{name: 'IdeaOverview', params: {id: idea.idPost}}">
        <span>{{ idea.headline }}</span>
      </router-link>
      <p> {{ idea.contentPost }}</p>
      <div class="box-bottom2">
        <div class="chartcircle chartcircle--1" data-chart="idea.completeLevel">
          <div class="chartcircle-wrapper">
            <div class="chartcircle-outer"></div>
            <div class="chartcircle-inner chartcircle-inner-left">
              <div v-if="process >= 180" class="chartcircle-inner-fill" :style="{opacity: 1, transform: `rotate(${process < 180 ? 0 : process - 180}deg)`}" />
            </div>
            <div class="chartcircle-inner chartcircle-inner-right">
              <div v-if="process" class="chartcircle-inner-fill" :style="{opacity: 1, transform: `rotate(${process > 180 ? 180 : process}deg)`}" />
            </div>
            <div class="chartcircle-number">{{ idea.completeLevel }}</div>
          </div>
        </div>
        <a class="link-icon--alt">Read more <i class="icon-arrow"></i></a>
      </div>
    </div>
  </div>

</template>

<!--//statuses: Under review, In progress, Approved, In development, Draft, Pending, Inactive-->
<!--//icons: underreview, inprogress, approved, indevelopment, draft, pending, inactive-->

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import moment from "moment-timezone";
export default {
  name: "IdeaBox",
  components: {ImageWrapper},
  props: ['idea'],
  computed: {
    process () {
      return this.idea.completeLevel / 100 * 360
    }

  },
  methods: {
    statusIcon(val) {
      switch (val) {
        case 'VOTING':
          return 'inactive'
        case 'FINISHED':
          return 'completed'
        case 'EVALUATION':
          return 'underreview'
      }
    },
    isOpenVoting(date) {
      return Math.floor((moment(date).unix() - moment().unix())) > 0
    }
  }
}
</script>

<style scoped>

</style>
